import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	topOfPanel: {
		id: 'backlog-panel.card.context-menu.top-of-panel',
		defaultMessage: 'Move to top',
		description: 'Label for context menu action to move a card to the top of panel',
	},
	bottomOfPanel: {
		id: 'backlog-panel.card.context-menu.bottom-of-panel',
		defaultMessage: 'Move to bottom',
		description: 'Label for context menu action to move a card to the bottom of panel',
	},
	up: {
		id: 'backlog-panel.card.context-menu.up',
		defaultMessage: 'Move up',
		description: 'Label for context menu action to move a card up',
	},
	down: {
		id: 'backlog-panel.card.context-menu.down',
		defaultMessage: 'Move down',
		description: 'Label for context menu action to move a card down',
	},
	movedToTop: {
		id: 'backlog-panel.card.context-menu.moved-to-top',
		defaultMessage: 'Moved epic to top of panel',
		description: 'Screen reader announce for move epic to top',
	},
	movedToBottom: {
		id: 'backlog-panel.card.context-menu.moved-to-bottom',
		defaultMessage: 'Moved epic to bottom of panel',
		description: 'Screen reader announce for move epic to bottom',
	},
	movedUp: {
		id: 'backlog-panel.card.context-menu.moved-up',
		defaultMessage: 'Moved epic up',
		description: 'Screen reader announce for move epic up',
	},
	movedDown: {
		id: 'backlog-panel.card.context-menu.moved-down',
		defaultMessage: 'Moved epic down',
		description: 'Screen reader announce for move epic down',
	},
});
